import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Box, Flex, Link, Text, ThemeUIStyleObject } from 'theme-ui';
import type { Author, SocialLink } from '../interfaces/articles.interfaces';

interface FooterProps {
  sx?: ThemeUIStyleObject;
}

const Footer: React.FC<FooterProps> = ({ sx }) => {
  const currentYear = new Date().getFullYear();

  const data = useStaticQuery(graphql`
    {
      contentfulAuthor(username: { eq: "edgartalledos" }) {
        id
        firstName
        lastName
        username
        socialNetworks {
          url
          name
          id
        }
      }
    }
  `);
  const author = data.contentfulAuthor as Author;
  const socialLinks = author.socialNetworks as SocialLink[];

  return (
    <Box
      sx={{
        backgroundColor: 'black',
        color: 'white',
        textAlign: 'center',
        py: 4,
        px: 3,
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        borderRadius: '4px',
        ...sx,
      }}
    >
      {/* Social Media Icons */}
      <Flex
        sx={{
          justifyContent: 'center',
          gap: 4,
          mb: 3,
        }}
      >
        {socialLinks.map((socialLink) => (
          <Link
            key={socialLink.id}
            href={socialLink.url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'white',
              transition: 'opacity 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                opacity: 0.8,
              },
            }}
            aria-label={socialLink.name}
          >
            {socialLink.name}
          </Link>
        ))}
      </Flex>

      <Text
        sx={{
          fontSize: 3,
          fontWeight: 'bold',
          mb: 2,
        }}
      >
        {`${author.firstName} ${author.lastName}`}
      </Text>

      {/* Copyright and Developer Info */}
      <Box p={2}>
        <Text sx={{ fontSize: 0, opacity: 0.9 }}>
          &copy;{currentYear} Todos los derechos reservados
        </Text>
      </Box>
    </Box>
  );
};

export default Footer;
